import clsx from "clsx";
import { ContactType, FindAllContactsFilters, FindContactsDatabaseResponse } from "../../../../../lib/filters/dto";
import { colors } from "../../../../../ui/colors";
import { GlobeIcon } from "../../../../../ui/icons/globe";
import Checkbox from "../../../../../ui/molecules/checkbox";
import { Pagination } from "../../../../../ui/organisms/pagination";
import { buildAddress } from "../../../../database/companies/list/table";
import { ContactsIdsResponseDTO } from "../../../contacts/dto";

interface Props {
  selectedIds: string[];
  setSelectedIds: (values: string[]) => void;
  contacts: FindContactsDatabaseResponse<ContactType.COMPANY>
  setFilters: (newFilters: Partial<FindAllContactsFilters>) => void
  changePage: (page: number) => void
  filters: FindAllContactsFilters
  targetContactIds: ContactsIdsResponseDTO[]
}
export function ImportFromDatabaseList(props: Props) {
  const { selectedIds, setSelectedIds, contacts, setFilters, changePage, filters, targetContactIds } = props;

  // const contactsIds = useAppSelector(state => state.contacts.getContactsIdsResponse)

  const isAlreadyIn = (id: string): boolean => {
    return targetContactIds?.find(contacts => contacts.contactType === ContactType.COMPANY)?.dto.find(company => company.contactId === id) !== undefined
  };

  // const isAlreadyIn = (id: string): boolean => {
  //   return targetContactIds?.find(company => company === id) !== undefined
  // };

  return (
    <div className="w-full" style={{ height: 'calc(100% - 176px)' }}>
      <div className="overflow-auto h-full">
        <table className="w-full">
          <thead className="bg-neutral-800 h-[48px] font-semibold text-neutral-500 uppercase sticky top-0 z-10 text-text-xs">
            <tr className="bg-neutral-50">
              <th className="text-left w-10 pl-4">
                <Checkbox
                  shape={"square"}
                  disabled={
                    contacts.data.every((company) =>
                      isAlreadyIn(company.id)
                    )!
                  }
                  checked={
                    contacts.data
                      .filter((company) => !isAlreadyIn(company.id))
                      .every((company) => selectedIds.includes(company.id))! ||
                    contacts.data.every((company) =>
                      isAlreadyIn(company.id)
                    )!
                  }
                  onCheck={function (value: boolean): void {
                    if (
                      contacts.data
                        .filter((company) => !isAlreadyIn(company.id))
                        .every((company) => selectedIds.includes(company.id))
                    ) {
                      let newSelected = [...selectedIds];
                      contacts.data.forEach(
                        (company) => {
                          newSelected = newSelected.filter(
                            (id) => company.id !== id
                          );
                        }
                      );
                      setSelectedIds([...newSelected]);
                    } else {
                      setSelectedIds([
                        ...selectedIds,
                        ...contacts.data
                          .filter(
                            (company) =>
                              !selectedIds.includes(company.id) &&
                              !isAlreadyIn(company.id)
                          )
                          .map((company) => company.id)!,
                      ]);
                    }
                  }}
                />
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">azienda</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">email</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">telefono</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">sede azienda</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">fatturato</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">P. IVA</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">ATECO</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">settore</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">categoria</div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">
                  <GlobeIcon color={colors.neutral[400]} size={16} />
                </div>
              </th>
              <th className="text-left">
                <div className="flex gap-[4px]">dipendenti</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {contacts.data.map((company) => (
              <tr
                className={clsx(
                  "h-[56px] border-b-[1px] border-b-neutral-100",
                  {
                    "bg-brandPrimary-100": selectedIds.includes(company.id),
                    "bg-white":
                      !selectedIds.includes(company.id) &&
                      !isAlreadyIn(company.id),
                    "bg-neutral-200 opacity-70":
                      !selectedIds.includes(company.id) &&
                      isAlreadyIn(company.id),
                  }
                )}
                key={company.id}
              >
                <td className="pl-4">
                  <Checkbox
                    shape={"square"}
                    disabled={isAlreadyIn(company.id)}
                    checked={
                      selectedIds.includes(company.id) ||
                      isAlreadyIn(company.id)
                    }
                    onCheck={function (value: boolean): void {
                      if (selectedIds.includes(company.id)) {
                        setSelectedIds([
                          ...selectedIds.filter((id) => id !== company.id),
                        ]);
                      } else {
                        setSelectedIds([...selectedIds, company.id]);
                      }
                    }}
                  />
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-brandPrimary-600">
                  {company.name ?? "-"}
                </td>
                <td>
                  {company.emails ? (
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={"mailto:" + company.emails}
                    >
                      <div className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                        {company.emails}
                      </div>
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
                <td>
                  {company.phones ? (
                    <a
                      rel="noreferrer"
                      target="_blank"
                      href={"tel:" + company.phones[0]?.phone}
                    >
                      <div className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                        {company.phones[0]?.phone + (company.phones.length > 1 ? (', ..., + ' + (company.phones.length - 1)) : '')}
                      </div>
                    </a>
                  ) : (
                    "-"
                  )}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {buildAddress(company.address, company.city, company.countryRegion, company.state, company.zipCode)}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.revenue ?? "-"}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.vat ?? "-"}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.ateco ? company.ateco?.atecoCode : "-"}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.ateco ? company.ateco?.sector : "-"}
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.ateco ? company.ateco?.category : "-"}
                </td>
                <td>
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href={company.website ?? undefined}
                  >
                    <GlobeIcon
                      color={
                        company.website
                          ? colors.neutral[400]
                          : colors.neutral[200]
                      }
                      size={20}
                    />
                  </a>
                </td>
                <td className="max-w-[150px] crop-text text-text-sm font-semibold text-neutral-600">
                  {company.employeesNumber ?? "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
        itemsPerPage={filters.itemsPerPage}
        setItemsPerPage={value => setFilters({ itemsPerPage: value })}
        found={contacts.total || 0}
        key={"pagination-companies-bottom"}
        pages={contacts.totalPage || 0}
        currentPage={contacts.page || 0}
        setPage={(page) => {
          changePage(page)
        }}
      />
    </div>
  );
}
